import React from 'react';
import { Box, Typography, Theme, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import intl from 'react-intl-universal';
import { Field } from 'redux-form';
import { GUEST_JOIN } from 'constants/ScheduleModal';
import MuiTextField from 'components/ModalInput/MuiInput';
import Button from 'components/Button/Button';
import { EXTENSION_STATE } from 'constants/Guest';

const NoExtension = ({ checkExtension, extensionValid, setExtensionValid }: any) => {
  const classes = extensionStyles();
  const guestForm = useSelector((state: any) => state?.app?.form[GUEST_JOIN]?.values);

  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (extensionValid !== EXTENSION_STATE.VALID) setExtensionValid('');
    if (event.key.toLowerCase() === 'enter') {
      checkExtension();
    }
  };

  return (
    <Box m={2} className={classes.noExtContainer}>
      {extensionValid === EXTENSION_STATE.INVALID ? (
        <Box mb={3}>
          <Typography data-testid="noExtensionError" variant="h3" color="error">
            {intl.get('extensionNotFound', { extension: guestForm?.extension })}
          </Typography>
        </Box>
      ) : null}
      <Typography variant="subtitle1" data-testid="enterExtensionHeader">
        {intl.get('enterExtension')}
      </Typography>
      <Box mt={4} onKeyDown={onKeyDown}>
        <Field
          component={MuiTextField}
          placeholder={intl.get('extension')}
          inputProps={{
            maxLength: 200,
            'data-testid': 'guest-extension-input'
          }}
          name={'extension'}
          required
          type="text"
          variant="outlined"
        />
      </Box>
      <Button
        className={classes.formField}
        kind="primary"
        dataAttrs={{
          'data-testid': 'next'
        }}
        onClick={checkExtension}
        disabled={!guestForm?.extension}
      >
        <Typography variant="button">{intl.get('next')}</Typography>
      </Button>
    </Box>
  );
};

const extensionStyles = makeStyles((theme: Theme) => ({
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 }
  },
  noExtContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: '100%',
    width: '500px',
    animationDuration: '0.5s',
    animationFillMode: 'forwards',
    animationName: '$fadeIn'
  },
  formField: {
    marginTop: theme.spacing(2),
    borderRadius: 0,
    width: '100%'
  }
}));

export default NoExtension;
